import styled from "styled-components";

export const PaginationWrapper = styled.ul`
  padding: 0;
`;

PaginationWrapper.displayName = "PaginationWrapper";
